import React from "react";
import { Col, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";

export default function NotFound() {
    return (
        <Container  className="vh-75 px-0">
        <Row>
            <Col>

                <h1>Page Not Found</h1>
                <p className="pt-5">
                    Sorry, but the page you were trying to view does not exist. Please click <a href="/">here</a> to go to home page.
                </p>
            </Col>
        </Row>
        </Container>

    );

}